"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const paymentList = (0, graphql_tag_1.default)`
  query tariff_paymentList {
    tariff {
      paymentList {
        amount
        paymentDate
        description
        user {
          id
          firstName
          lastName
          juristicPersonLegalForm
          juristicPersonName
          personType
          accessLevel
          membership
          role
          active
          showMyAvatar
          avatarColor
          avatarBorderColor
          avatarText
          avatarDisplayName
          avatarUrl
          hasPrivateProfile
          isRegistered
        }
      }
    }
  }
`;
exports.default = paymentList;